import type { CollectionEntity } from 'bundles/collections-carousel/types/CarouselCollection';
import type { ProductCardSimilarSpecializationFragmentFragment as ProductCardSimilarSpecializationFragment } from 'bundles/unified-description-page-common/queries/__generated__/ProductCardSimilarSpecializationFragment';
import {
  getCollectionEntity,
  mapDifficultyLevel,
} from 'bundles/unified-description-page-common/utils/dataTransformation';

export const useConvertXdpSimilarProductToCollectionEntity = () => {
  return (
    product: ProductCardSimilarSpecializationFragment,
    entityIndex: number,
    removeFreeTrialBadge: boolean = false
  ): CollectionEntity | null => {
    const { id, marketingProductType, productTypeAttributes, badges } = product;
    if (productTypeAttributes.__typename === 'ProductCard_Specialization') {
      const { isPathwayContent, isPartOfCourseraPlus, hasTopInstructor, totalAssignmentCount } = productTypeAttributes;
      const {
        cardImageUrl,
        difficultyLevel,
        name,
        partners,
        slug,
        rating,
        urlPath,
        skillTags,
        coBrandingEnabled,
        launchedAt,
      } = productTypeAttributes.canonical.latestSpecialization;

      let productType;
      if (marketingProductType === 'SPECIALIZATION') productType = 'SPECIALIZATION' as const;
      else if (marketingProductType === 'PROFESSIONAL_CERTIFICATE') productType = 'PROFESSIONAL CERTIFICATE' as const;

      let badgesToUse = badges || [];

      if (removeFreeTrialBadge) {
        badgesToUse = badgesToUse.filter((badge) => badge !== 'Free Trial');
      }

      return getCollectionEntity({
        productId: id,
        name,
        slug,
        imageUrl: cardImageUrl,
        badges: badgesToUse,
        productType,
        urlPath,
        isPartOfCourseraPlus,
        reviewCount: rating?.ratingCount ?? 0,
        rating: rating?.averageFiveStarRating ?? 0,
        isPathwayContent,
        productDifficultyLevel: mapDifficultyLevel(difficultyLevel),
        partners: partners.map((partner) => ({
          id: partner.id,
          name: partner.name,
          squareLogo: partner.squareLogo ?? '',
        })),
        skillsTags:
          skillTags?.map((skill) => ({
            id: skill.skillId,
            name: skill.skillName,
            isToolSoftware: skill.isToolSoftware,
          })) ?? [],
        coBrandingEnabled,
        lastUpdated: launchedAt ?? undefined,
        totalAssignmentCount,
        hasTopInstructor,
        entityIndex,
      });
    }

    return null;
  };
};
